// extracted by css-extract-rspack-plugin
export default {"table":"table-kbMuYb","filter":"filter-bjkr_R","spacer":"spacer-WI51gV","list-item":"list-item-tdoZXz","listItem":"list-item-tdoZXz"};